import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Info as InfoIcon } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import { TextWithBreaks } from "../text/TextWithBreaks.js";
export const InfoMessage = ({ message }) => {
    const theme = useTheme();
    return (_jsxs(Box, { display: "flex", flex: 1, flexDirection: "column", justifyContent: "center", alignItems: "center", children: [_jsx(InfoIcon, { color: "secondary" }), _jsx(Box, { mt: 2, children: _jsx(Typography, { align: "center", children: _jsx(TextWithBreaks, { text: message }) }) })] }));
};
//# sourceMappingURL=InfoMessage.js.map